import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Lock, Unlock } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { api, formatErr } from "@/lib/api";

const NOTES = { apprenticeship: "Cohort starts Fall/Winter 2026" };

const Lessons = ({ cohort }) => {
  const [lessons, setLessons] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    api.get(`/courses/${cohort}/lessons`).then((r) => setLessons(r.data)).catch((e) => setError(formatErr(e)));
  }, [cohort]);
  if (error) return <p className="text-sm text-[#9c3d5c]">{error}</p>;
  if (!lessons) return <p className="text-sm text-[#232b1b]/60">Opening your lessons…</p>;
  if (!lessons.length) return <p data-testid={`lessons-empty-${cohort}`} className="text-sm text-[#232b1b]/65">Your lessons are being prepared with care. They will appear here soon.</p>;
  return (
    <Accordion type="single" collapsible data-testid={`lessons-${cohort}`}>
      {lessons.map((l, i) => (
        <AccordionItem key={l.id} value={l.id}>
          <AccordionTrigger data-testid={`lesson-trigger-${l.id}`} className="font-serif-h text-xl text-left">Lesson {i + 1}: {l.title}</AccordionTrigger>
          <AccordionContent className="whitespace-pre-line leading-relaxed text-[#232b1b]/80">{l.body}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export const Courses = () => {
  const [courses, setCourses] = useState([]);
  useEffect(() => {
    api.get("/courses").then((r) => setCourses(r.data));
  }, []);
  return (
    <div data-testid="members-courses">
      <span className="eyebrow">Your Classes & Courses</span>
      <h1 className="font-serif-h font-light text-4xl sm:text-5xl text-[#577731] mt-4">Your lessons, waiting whenever you are ready</h1>
      <div className="space-y-8 mt-12">
        {courses.map((c) => (
          <section key={c.key} data-testid={`course-${c.key}`} className={`card-soft p-8 ${c.unlocked ? "" : "bg-[#d4d3d3]/30"}`}>
            <div className="flex items-start justify-between gap-4">
              <div>
                <h2 className="font-serif-h text-3xl text-[#232b1b]">{c.name}</h2>
                {NOTES[c.key] && <p className="text-xs uppercase tracking-widest text-[#b6689a] mt-2">{NOTES[c.key]}</p>}
              </div>
              {c.unlocked ? <Unlock className="text-[#577731] shrink-0" /> : <Lock data-testid={`course-locked-${c.key}`} className="text-[#b6689a] shrink-0" />}
            </div>
            <div className="mt-6">
              {c.unlocked ? (
                <Lessons cohort={c.key} />
              ) : (
                <div>
                  <p className="text-sm text-[#232b1b]/70">These lessons open to students enrolled in this cohort. Being an Ambassador holds your seat in the circle; enrollment opens the classroom.</p>
                  <Link to={`/apply?program=${c.key}`} data-testid={`course-apply-${c.key}`} className="btn btn-ghost mt-5">Apply for this cohort</Link>
                </div>
              )}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
};
